var map = {
	"./JPEG/bahnhof.jpg": 7653,
	"./JPEG/baustelle.jpg": 2490,
	"./JPEG/business_viertel.jpg": 3395,
	"./JPEG/einkaufszentrum.jpg": 454,
	"./JPEG/energielandschaft.jpg": 994,
	"./JPEG/fabrik.jpg": 9838,
	"./JPEG/flughafen.jpg": 1139,
	"./JPEG/forschung.jpg": 2130,
	"./JPEG/fussballstadion.jpg": 8607,
	"./JPEG/hafen.jpg": 6465,
	"./JPEG/koelner_dom.jpg": 2264,
	"./JPEG/museum.jpg": 9533,
	"./JPEG/startups.jpg": 4319,
	"./JPEG/universitaeten.jpg": 2071,
	"./JPEG/wald.jpg": 5725,
	"./bahnhof.jpg": 264,
	"./baustelle.jpg": 5319,
	"./business_viertel.jpg": 6824,
	"./einkaufszentrum.jpg": 1323,
	"./energielandschaft.jpg": 2075,
	"./fabrik.jpg": 1933,
	"./flughafen.jpg": 62,
	"./forschung.jpg": 3963,
	"./fussballstadion.jpg": 9362,
	"./hafen.jpg": 2964,
	"./koelner_dom.jpg": 9057,
	"./multikulturellesviertel.jpg": 3176,
	"./museum.jpg": 6186,
	"./startups.jpg": 4424,
	"./universitaeten.jpg": 104,
	"./wald.jpg": 5658
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4728;